<template>
  <bulletin-button
    :variant="isFavoriteBrand ? 'selectedActionChip' : 'primary'"
    no-min-width
    small-padding
    class="follow-button"
    @click="handleButtonClick()"
    >{{ isFavoriteBrand ? "following" : "follow" }}</bulletin-button
  >
</template>

<style scoped lang="scss">
.follow-button {
  padding-inline: 16px !important;
  height: 32px !important;
}
</style>

<script>
import InlineSvg from "vue-inline-svg";
import FavoritesApi from "../../services/api/favoritesApi";
const favoritesApiService = new FavoritesApi();
export default {
  components: {
    InlineSvg,
  },
  props: ["brandId"],
  data() {
    return {
      isActive: false,
    };
  },
  computed: {
    isFavoriteBrand() {
      const faveState = this.$store.state.favoriteState;
      return faveState.includes(this.brandId);
    },
  },
  methods: {
    handleButtonClick,
  },
};
async function handleButtonClick() {
  const brandLists = this.$store.state.favoriteState;
  this.$notify.$emit("fire", {
    message: this.isFavoriteBrand
      ? "removed from your favorites"
      : "ADDED TO YOUR  <a href='/dashboard/favorites'>FAVORITES!</a>",
    type: "success-top-center",
    fadeTime: 3500,
  });
  if (this.isFavoriteBrand) {
    favoritesApiService.favoriteBrandToggle(this.brandId);
    const filteredArray = brandLists.filter((id) => id !== this.brandId);
    this.$store.commit("setFavoriteState", filteredArray);
    this.$emit("unfollow-click");
  } else {
    await favoritesApiService.favoriteBrandToggle(this.brandId);
    const { data } = await favoritesApiService.getFavoriteBrands();
    this.$store.commit("setFavoriteState", data.brand_ids);
    //parent component is tracking follow clicks
    this.$emit("follow-click");
  }
}
</script>
